var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("router-view", { key: _vm.$route.path })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }